import { FunctionComponent, ReactNode } from "react";
import { LucideIcon } from "lucide-react";
import "./EmptyState.scss";

interface EmptyStateProps {
  icon?: LucideIcon;
  iconSize?: number;
  title: ReactNode;
  description?: ReactNode;
  /** acao opcional embaixo (botao, link, etc.) */
  action?: ReactNode;
  className?: string;
}

const EmptyState: FunctionComponent<EmptyStateProps> = ({
  icon: Icon,
  iconSize = 32,
  title,
  description,
  action,
  className = "",
}) => {
  return (
    <div className={`empty-state ${className}`.trim()}>
      {Icon && <Icon size={iconSize} />}
      <p>{title}</p>
      {description && <small>{description}</small>}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  );
};

export default EmptyState;
